import { useLanguage } from "../context/LanguageContext";

export default function DevWarning() {
  const { t } = useLanguage();

  return (
    <div className="border border-gray-300 rounded bg-gray-100 h-24 p-2 flex align-center">
      <p className="my-auto mx-auto font-light text-lg text-gray-800">
        {t.devWarning.devWarning}
      </p>
    </div>
  );
}
